<template>
  <div>
    <b-row>
      <b-col
        lg="3"
        md="6"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <foreignObject
            width="100%"
            height="100%"
            x="25"
            y="25"
          >
            <div>
              <b-img
                src="@/assets/images/icons/VMS.svg"
              />
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="70"
            y="25"
            color="#ffffff"
          >
            <div>
              <span style="font-weight: 600; font-size:20px">จำนวนจุดติดตั้งทั้งหมด</span>
            </div>
          </foreignObject>
          <foreignObject
            x="30"
            y="70"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <span style="text-align:left; font-weight: 700; font-size:40px">
              {{ total }}
            </span>
            <span
              style="text-align:center; font-weight: 600; font-size:20px"
            >
              จุด
            </span>
          </foreignObject>
          <path
            d="M16.5 143.5L1 128V8.5H318.693L331.5 0.5H357V8.5V128L341.5 143.5H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 0H328.5L317.5 7H313.5L324.5 0Z"
            fill="#00B058"
          />
          <path
            d="M317.5 0H321.5L310.5 7H306.5L317.5 0Z"
            fill="#00B058"
          />
          <path
            d="M310.5 0H314.5L303.5 7H299.5L310.5 0Z"
            fill="#00B058"
          />
          <path
            d="M303.5 0H307.5L296.5 7H292.5L303.5 0Z"
            fill="#00B058"
          />
          <path
            d="M296.5 0H300.5L289.5 7H285.5L296.5 0Z"
            fill="#00B058"
          />
          <path
            d="M289.5 0H293.5L282.5 7H278.5L289.5 0Z"
            fill="#00B058"
          />
        </svg>
      </b-col>
      <b-col
        lg="3"
        md="6"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <foreignObject
            width="100%"
            height="100%"
            x="25"
            y="25"
          >
            <div>
              <b-img
                src="@/assets/images/icons/pin_vms.svg"
              />
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="70"
            y="25"
            color="#ffffff"
          >
            <div>
              <span style="font-weight: 600; font-size:20px">สถานที่ติดตั้งสูงสุด</span>
            </div>
          </foreignObject>
          <foreignObject
            x="150"
            y="50"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <span style="text-align:left; font-weight: 700; font-size:40px">
              {{ totalLocation }}
            </span>
            <span
              style="position: relative; text-align:center; font-weight: 600; font-size:20px"
            >
              จุด
            </span>
          </foreignObject>
          <foreignObject
            x="40"
            y="105"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <span
              style="position: relative; font-weight: 600; font-size:20px"
            >
              ({{ totalWayID }})
            </span>
          </foreignObject>
          <path
            d="M16.5 143.5L1 128V8.5H318.693L331.5 0.5H357V8.5V128L341.5 143.5H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 0H328.5L317.5 7H313.5L324.5 0Z"
            fill="#00B058"
          />
          <path
            d="M317.5 0H321.5L310.5 7H306.5L317.5 0Z"
            fill="#00B058"
          />
          <path
            d="M310.5 0H314.5L303.5 7H299.5L310.5 0Z"
            fill="#00B058"
          />
          <path
            d="M303.5 0H307.5L296.5 7H292.5L303.5 0Z"
            fill="#00B058"
          />
          <path
            d="M296.5 0H300.5L289.5 7H285.5L296.5 0Z"
            fill="#00B058"
          />
          <path
            d="M289.5 0H293.5L282.5 7H278.5L289.5 0Z"
            fill="#00B058"
          />
        </svg>
      </b-col>
      <!-- ---------------total location----------- -->
      <b-col
        lg="3"
        md="6"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <foreignObject
            width="100%"
            height="100%"
            x="25"
            y="25"
          >
            <div>
              <b-img
                src="@/assets/images/icons/Online.svg"
              />
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="70"
            y="25"
            color="#ffffff"
          >
            <div>
              <span style="font-weight: 600; font-size:20px; margin-left: 5px;">ใช้งานได้</span>
            </div>
          </foreignObject>
          <foreignObject
            x="30"
            y="70"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <span style="text-align:left; font-weight: 700; font-size:40px">
              {{ online }}
            </span>
            <span
              style="text-align:center; font-weight: 600; font-size:20px"
            >
              จุด
            </span>
          </foreignObject>
          <path
            d="M16.5 143.5L1 128V8.5H318.693L331.5 0.5H357V8.5V128L341.5 143.5H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 0H328.5L317.5 7H313.5L324.5 0Z"
            fill="#00B058"
          />
          <path
            d="M317.5 0H321.5L310.5 7H306.5L317.5 0Z"
            fill="#00B058"
          />
          <path
            d="M310.5 0H314.5L303.5 7H299.5L310.5 0Z"
            fill="#00B058"
          />
          <path
            d="M303.5 0H307.5L296.5 7H292.5L303.5 0Z"
            fill="#00B058"
          />
          <path
            d="M296.5 0H300.5L289.5 7H285.5L296.5 0Z"
            fill="#00B058"
          />
          <path
            d="M289.5 0H293.5L282.5 7H278.5L289.5 0Z"
            fill="#00B058"
          />
        </svg>
      </b-col>
      <b-col
        lg="3"
        md="6"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <foreignObject
            width="100%"
            height="100%"
            x="25"
            y="25"
          >
            <div>
              <b-img
                src="@/assets/images/icons/Offline.svg"
              />
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="70"
            y="25"
            color="#ffffff"
          >
            <div>
              <span style="font-weight: 600; font-size:20px; margin-left: 5px;">ใช้งานไม่ได้</span>
            </div>
          </foreignObject>
          <foreignObject
            x="30"
            y="70"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <span style="text-align:left; font-weight: 700; font-size:40px">
              {{ offline }}
            </span>
            <span
              style="text-align:center; font-weight: 600; font-size:20px"
            >
              จุด
            </span>
          </foreignObject>
          <foreignObject
            x="230"
            y="95"
            width="300"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <b-card-header style="margin-top: 10px; text-align: right;">
              <b-button
                id="toggle-btn"
                v-b-modal="'modalVMSOffline'"
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                variant="flat-primary"
                style="font-size: 14px;"
                title="Click to show more"
              >
                <span
                  class="align-middle"
                  style="color: #11DF00;"
                >
                  ดูเพิ่มเติม
                  <feather-icon
                    icon="ChevronsRightIcon"
                    size="14"
                  />
                </span>
              </b-button>
            </b-card-header>
          </foreignObject>
          <path
            d="M16.5 143.5L1 128V8.5H318.693L331.5 0.5H357V8.5V128L341.5 143.5H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 0H328.5L317.5 7H313.5L324.5 0Z"
            fill="#00B058"
          />
          <path
            d="M317.5 0H321.5L310.5 7H306.5L317.5 0Z"
            fill="#00B058"
          />
          <path
            d="M310.5 0H314.5L303.5 7H299.5L310.5 0Z"
            fill="#00B058"
          />
          <path
            d="M303.5 0H307.5L296.5 7H292.5L303.5 0Z"
            fill="#00B058"
          />
          <path
            d="M296.5 0H300.5L289.5 7H285.5L296.5 0Z"
            fill="#00B058"
          />
          <path
            d="M289.5 0H293.5L282.5 7H278.5L289.5 0Z"
            fill="#00B058"
          />
        </svg>
      </b-col>
    </b-row>
    <ModalVMSOffline />
  </div>
</template>

<script>
import {
  BRow, BCol, BImg, BButton,
} from 'bootstrap-vue'
import axios from '@axios'
import ModalVMSOffline from '@/views/vms/total/ModalVMSOffline.vue'

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BButton,
    ModalVMSOffline,
  },
  data() {
    return {
      total: '',
      online: '',
      offline: '',
      totalLocation: '',
      totalWayID: '',
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.getSumCCTV()
    this.getCCTVTop()
  },
  mounted() {
    this.interval = setInterval(() => {
      this.getSumCCTV()
      this.getCCTVTop()
    }, 300000)
  },
  methods: {
    getCCTVTop() {
      axios
        .post('/getTop5TotalVMS', { department: this.userData.department })
        .then(response => {
          // eslint-disable-next-line prefer-destructuring
          this.totalLocation = response.data[0].Location_VMS
          this.totalWayID = response.data[0].WayID
        })
        .catch(error => {
          console.log(error)
        })
    },
    getSumCCTV() {
      axios
        .post('/getStaticTotalVMS', { department: this.userData.department })
        .then(response => {
          this.total = response.data[0].VMS_Total
          this.online = response.data[0].VMS_Online
          this.offline = response.data[0].VMS_Offline
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style>
</style>
